import { render, staticRenderFns } from "./UploadCustomerDocumentForm.vue?vue&type=template&id=ecef7d6a&scoped=true&"
import script from "./UploadCustomerDocumentForm.vue?vue&type=script&lang=js&"
export * from "./UploadCustomerDocumentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecef7d6a",
  null
  
)

export default component.exports